export default __webpack_public_path__ + "static/media/sz.7b1de13a.svg";